import styled from 'styled-components'
import checked from './checked.svg'
import unchecked from './unchecked.svg'
import { mildGray } from '../../styles/variables'

const Checkbox = styled.div`
  display: flex;
  align-items: center;
  user-select: none;

  ${( { readOnly }) => readOnly ? 'opacity: 0.7;' : ''}

  label {
    font-size: 16px;
    padding-left: 10px;
    cursor: pointer;
    color: ${mildGray};
  }

  input {
    opacity: 0;
    visibility: hidden;
    position: absolute;
  }

  input:checked ~ .check {
    border-color: #00ff8f;
  }
  input:checked ~ .check::after {
    opacity: 1;
    transform: scale(1);
  }

  .check {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-size: 100%;
    background-image: url("${unchecked}");
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .check::after {
    content: '';
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 4;
    position: absolute;
    transform: scale(0);
    background-size: 100%;
    background-image: url("${checked}");
    background-repeat: no-repeat;
    background-position: center;
}
`

export default {
  Checkbox,
}
